import React, { useState, useEffect } from "react";
import "./Table.css";
import axios from "axios";
import { config } from "../../confi";
import { SearchOutlined } from "@ant-design/icons";
import Spinner from "../Loader/Spinner";

function Table() {
  let [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [Search, setSearch] = useState("");
  const [Limit,Setlimit]  = useState(10)

  const [loading, setLoading] = useState(false);
 

  //--------  data fetch function  ---------////

  ///////////////--------------search ------////

  async function FetchSearch() {
    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_fe_me_one",
      payload: { member_id: Search,limit:Limit },
    });

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200 && response.data.status === "0") {
        setData(response.data.data);
      } else {
      }
    } catch (error) {}
    setLoading(false);
  }

  useEffect(() => {
    async function FetchHandler() {
      let reqbody = JSON.stringify({
        fn: "common_fun",
        an: "fn_fe_Al_me",
        payload: { page: currentPage ,limit:Limit},
      });

      try {
        setLoading(true);

        const response = await axios.post(
          `${config.apiBaseURL}/root`,
          { data: reqbody },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        if (response.status === 200 && response.data.status === "0") {
          setData(response.data.data);
        } else {
        }
      } catch (error) {}
      setLoading(false);
    }
    FetchHandler();
  }, [currentPage,Limit]);

  return (
    <div className="my-table">
      <div>
        {loading ? (
          <span style={{ textAlign: "center" }}>
            {" "}
            <Spinner />
          </span>
        ) : (
          <div>
            <div className="div-for-search">
              <label style={{ fontWeight: "bold" }}>
                (Name/Mob. No./Rec. No.)
              </label>
              <div>
              <input
                className="table-search"
                type="text"
                value={Search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                placeholder="Search..."
              ></input>
              <button className="search-btn-56" onClick={FetchSearch}>
                <SearchOutlined />
              </button>
              </div>
            </div>
            <table className="my-table-main">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>F. Name</th>
                  <th>Member Rec. No.</th>
                  <th>Mobile No.</th>
                  <th>Year</th>
                </tr>
              </thead>
              {Data.length > 0 ? (
                <tbody>
                  {Data.map((e, i) => {
                    return (
                      
                        <tr key={i}>
                          <td>{e.name_person}</td>
                          <td>{e.father_hus_name}</td>
                          <td>{e.membership_rec_no}</td>
                          <td>{e.mobile_no}</td>
                          <td>{e.membership_year}</td>
                        </tr>
                    
                    );
                  })}
                </tbody>
              ) : (
                <span style={{ textAlign: "center", display: "inline-block" }}>
                  {" "}
                  No Record
                </span>
              )}
            </table>

            <div style={{ marginTop: "5px", textAlign: "center" }}>
              <button
                className={`${
                  currentPage === 1
                    ? "pagination-btn-disabled"
                    : "pagination-btn "
                }`}
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="Page-text">Page {currentPage}</span>
              <button
                className={`${
                  Data.length < 10
                    ? "pagination-btn-disabled"
                    : "pagination-btn "
                }`}
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage < 1 || Data.length < 10}
              >
                Next
              </button>
              <select className="limit-input" placeholder="Select Limit" name ="limit-select" value={Limit} onChange={(e)=>{Setlimit(e.target.value)}}>
                  <option  value="10">10</option>
                  <option  value="20">20</option>
                  <option  value="50">50</option>
                  <option  value="100">100</option>
                </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Table;

